import { Operation, Partner, Transaction } from 'types';

export const getPartnersFromOldSplit = (
  operation: Operation | undefined
): Partner[] => {
  if (!operation?.transactions?.length) return [];

  const partners = (operation.transactions as Transaction[])
    .map((transaction) => transaction.partner)
    .filter((partner): partner is Partner => !!partner);

  const unique = new Map(partners.map((p) => [p._id, p]));

  return [...unique.values()];
};
